<template>
  <v-card style="width:100%;" class="ma-4">
    <v-row v-if="!showMobileView">
      <v-col class="mx-4 py-5">
        <span style="font-size: 12px;" class="ml-3">Screen</span>
        <div class="d-flex align-center ml-3 justify-space-between">
          <h2>{{ data.screen_id }}</h2>
          <v-btn
            color="black"
            style="color:white; font-weight:bold;"
            @click="openEmail(data.screen.group.contact_email)"
            ><v-icon class="pr-2">mdi-email</v-icon>Email Contact</v-btn
          >
        </div>
      </v-col>
    </v-row>
    <div :class="parentDivClass">
      <span style="font-size: 16px;" class="ml-3 pt-4" v-if="showMobileView"
        >Call Status</span
      >
      <v-item-group
        v-model="status"
        :class="buttonsClass"
        :style="callStatusStyle"
      >
        <v-row class="d-flex justify-center">
          <div class="pa-0 d-flex flex-column">
            <v-item
              v-slot:default="{ active, toggle }"
              class="ma-1"
              value="1st attempt"
            >
              <v-btn
                class="text-capitalize"
                tile
                elevation="0"
                width="99"
                :style="
                  active
                    ? `border: 2px solid ${$vuetify.theme.currentTheme.secondary};
                  background-color: white;`
                    : ''
                "
                @click="toggle"
                >1st Attempt</v-btn
              >
            </v-item>
            <v-item
              v-slot:default="{ active, toggle }"
              class="mx-1 mb-1"
              value="none"
            >
              <v-btn
                class="text-capitalize"
                tile
                elevation="0"
                width="99"
                :style="
                  active
                    ? `border: 2px solid ${$vuetify.theme.currentTheme.secondary};
                  background-color: white;`
                    : ''
                "
                @click="toggle"
                >None</v-btn
              >
            </v-item>
          </div>
          <div class="pa-0 d-flex flex-column">
            <v-item
              v-slot:default="{ active, toggle }"
              class="mt-1"
              value="2nd attempt"
            >
              <v-btn
                class="text-capitalize"
                tile
                elevation="0"
                width="99"
                :style="
                  active
                    ? `border: 2px solid ${$vuetify.theme.currentTheme.secondary};
                  background-color: white;`
                    : ''
                "
                @click="toggle"
                >2nd Attempt</v-btn
              >
            </v-item>
            <v-item
              v-slot:default="{ active, toggle }"
              class="my-1"
              value="locating"
            >
              <v-btn
                class="text-capitalize"
                tile
                elevation="0"
                width="99"
                :style="
                  active
                    ? `border: 2px solid ${$vuetify.theme.currentTheme.secondary};
                  background-color: white;`
                    : ''
                "
                @click="toggle"
                >Locating</v-btn
              >
            </v-item>
          </div>
          <div class="pa-0 d-flex flex-column">
            <v-item
              v-slot:default="{ active, toggle }"
              class="ma-1"
              value="escalated"
            >
              <v-btn
                class="text-capitalize"
                tile
                elevation="0"
                width="99"
                :style="
                  active
                    ? `border: 2px solid ${$vuetify.theme.currentTheme.secondary};
                  background-color: white;`
                    : ''
                "
                @click="toggle"
                >Escalated</v-btn
              >
            </v-item>
            <v-item
              v-slot:default="{ active, toggle }"
              class="mx-1 mb-1"
              value="missing"
            >
              <v-btn
                class="text-capitalize"
                tile
                elevation="0"
                width="99"
                :style="
                  active
                    ? `border: 2px solid ${$vuetify.theme.currentTheme.secondary};
                  background-color: white;`
                    : ''
                "
                @click="toggle"
                >Missing</v-btn
              >
            </v-item>
          </div>
        </v-row>
      </v-item-group>
      <div v-if="showMobileView">
        <v-row
          v-for="(info, i) in genInfo"
          :key="i"
          class="d-flex justify-space-between"
        >
          <v-col cols="5" class="py-0" style="min-width: 50%;">
            <v-card-text class="pb-0 pt-3" style="font-size: 20px;">
              {{ info.name }}
            </v-card-text>
          </v-col>
          <v-col cols="5" class="py-0">
            <v-card-text
              class="pb-0 pt-3 d-flex justify-end"
              style="font-size: 20px;"
            >
              {{ info.value }}
            </v-card-text>
          </v-col>
        </v-row>
        <div style="width:100%;" class="d-flex justify-center pt-3">
          <v-btn color="black" style="color:white; font-weight:bold; width:95%;"
            ><v-icon class="pr-2">mdi-email</v-icon>Email Contact</v-btn
          >
        </div>
      </div>
      <div class="d-flex flex-wrap mb-4" v-if="!showMobileView">
        <v-layout
          v-for="(info, i) in genInfo"
          :key="i"
          class="d-flex justify-space-between flex-column"
          style="max-width:25%; min-width:25%;"
        >
          <v-col class="py-0" style="min-width: 50%;">
            <v-card-text class="pb-0 pt-3" style="font-size: 12px;">
              {{ info.name }}
            </v-card-text>
          </v-col>
          <v-col class="py-0" v-if="info.name !== 'Confirmed'">
            <v-card-text
              class="pb-0 pt-3 font-weight-bold d-flex"
              style="font-size: 16px;"
            >
              {{ info.value }}
            </v-card-text>
          </v-col>
          <v-col class="py-0" v-if="info.name === 'Confirmed'">
            <v-card-text
              class="pb-0 pt-3 font-weight-bold d-flex"
              style="font-size: 16px;"
            >
              <v-checkbox dense v-model="info.value" class="mt-0 pt-0" />
              <span v-if="info.value">Yes</span>
              <span v-if="!info.value">No</span>
            </v-card-text>
          </v-col>
        </v-layout>
      </div>
    </div>
  </v-card>
</template>

<script>
import moment from 'moment';
import { mapActions } from 'vuex';
import ReconciliationDetailData from '@/mixins/ReconciliationDetailData';
import { MobileView } from '@/mixins';

export default {
  data: () => ({
    status: 'none',
  }),
  mixins: [ReconciliationDetailData, MobileView],
  methods: {
    ...mapActions({
      _uploadDetails: 'reconciliationDetails/uploadDetails',
    }),
    setTime(date) {
      return moment.unix(date).format('YYYY-MM-DD HH:mm');
    },
    openEmail(email) {
      window.location.href = `mailto:${email}`;
    },
  },
  computed: {
    callStatusStyle() {
      if (this.showMobileView) {
        return 'width:100%;';
      }
      return 'width:25%';
    },
    parentDivClass() {
      if (this.showMobileView) {
        return 'd-flex pb-5 flex-column';
      }
      return 'd-flex pb-5';
    },
    buttonsClass() {
      if (this.showMobileView) {
        return ' pa-5';
      }
      return 'pa-5 ml-4 mr-5';
    },
    genInfo() {
      return [
        {
          name: 'RA #',
          value: this.data.ra_number,
        },
        {
          name: 'Originating Location',
          value: this.data.group_id,
        },
        {
          name: 'Destination Location',
          value: this.data.destination,
        },
        {
          name: 'Rental Date',
          value: this.setTime(this.data.start_at),
        },
        {
          name: 'Due Date',
          value: this.setTime(this.data.expected_end_at),
        },
        {
          name: 'Status',
          value: this.data.rental_status,
        },
        {
          name: 'Confirmed',
          value: this.data.checked,
        },
      ];
    },
  },
  watch: {
    status() {
      if (this.status !== this.data.call_status) {
        const dataCopy = JSON.parse(JSON.stringify(this.data));
        dataCopy.call_status = this.status;
        delete dataCopy.error;
        delete dataCopy.success;
        delete dataCopy.type_name;
        delete dataCopy.rental_status;
        this._uploadDetails(dataCopy);
      }
    },
    data: {
      handler() {
        if (!this.data.call_status) {
          const dataCopy = JSON.parse(JSON.stringify(this.data));
          dataCopy.call_status = this.status;
          delete dataCopy.error;
          delete dataCopy.success;
          delete dataCopy.type_name;
          delete dataCopy.rental_status;
          this._uploadDetails(dataCopy);
        } else {
          this.status = this.data.call_status;
        }
      },
    },
    deep: true,
  },
};
</script>

<style></style>
